import { Country } from '~/Api/Country';

import Sentence from './Sentence';
import VirtualBrand from './VirtualBrand';

export enum StoryType {
	priceChange = 'price-change',
	packagePriceIntroduced = 'package-price-introduced',
	brandPriceIntroduced = 'brand-price-introduced',
	eaMahRegistration = 'eu-mah-registration',
}

export default class Record {
	storyType: StoryType;

	yearMonth: Date;

	country: Country;

	virtualBrand: VirtualBrand;

	summary: Sentence;

	context: Sentence[];

	constructor(
		storyType: StoryType,
		yearMonth: Date,
		country: Country,
		virtualBrand: VirtualBrand,
		summary: Sentence,
		context: Sentence[]
	) {
		this.storyType = storyType;
		this.yearMonth = yearMonth;
		this.country = country;
		this.virtualBrand = virtualBrand;
		this.summary = summary;
		this.context = context;
	}

	get hash(): string {
		return JSON.stringify(this);
	}
}
